module.exports = __webpack_public_path__ + "img/asiatic-lilly.9f2dd019.jpg";